import React from 'react'
import { PrivacyPolicyTemplate } from '@/components/templates/PrivacyPolicyTemplate'
import { NextSeo } from 'next-seo'
import { GetStaticProps } from 'next'
import { MainPage } from '@/layouts/MainPage'

const PrivacyPolicy = () => {
  return (
    <MainPage>
      <NextSeo title='Política de Privacidade - Inovando' />
      <PrivacyPolicyTemplate />
    </MainPage>
  )
}

export default PrivacyPolicy

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
  }
}
